import axios from 'axios';
import { API_BASE_URL } from './apiConfig.js';

export const trackEvent = async (sessionId, eventType, eventTarget, eventData = {}) => {
  // 1. Dynamic Researcher Check: Check for the 'researcher' role in localStorage
  const currentUserRole = localStorage.getItem("userRole");
  
  // 2. Retrieve the assigned Experiment ID from sessionStorage
  const experimentId = sessionStorage.getItem("experimentId");

  // Skip tracking for researchers, RESEARCH_MODE, or if the sessionId is missing
  if (currentUserRole === "researcher" || sessionId === "RESEARCH_MODE" || !sessionId) {
    // console.log("Tracking skipped: Researcher activity or missing session.");
    return;
  }

  try {
    // 3. Send the experimentId so we can group the participants
    await axios.post(`${API_BASE_URL}/api/track-event`, {
      sessionId,
      eventType,
      eventTarget,
      eventData: JSON.stringify(eventData),
      experimentId: experimentId || 1 // Fallback to '1' (Control) if none is found
    });
  } catch (err) {
    console.error("Failed to track event:", err);
  }
};